"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _initializerDefineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerDefineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));

var _initializerWarningHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerWarningHelper"));

var _react = _interopRequireWildcard(require("react"));

var _aphrodite = require("aphrodite");

var _mobx = require("mobx");

var _mobxReact = require("mobx-react");

var _objectHash = _interopRequireDefault(require("object-hash"));

var _Popover = _interopRequireDefault(require("../Popover"));

var _TextInput = _interopRequireDefault(require("./TextInput"));

var _styling = require("../../toolkit/styling");

var _providers = require("../../toolkit/providers");

var _class, _class2, _descriptor, _descriptor2, _descriptor3, _class3, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var TypeaheadInput = (0, _mobxReact.observer)(_class = (_class2 = (_temp = _class3 = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(TypeaheadInput, _Component);

  var _super = _createSuper(TypeaheadInput);

  function TypeaheadInput() {
    var _this;

    (0, _classCallCheck2["default"])(this, TypeaheadInput);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.context = void 0;
    (0, _initializerDefineProperty2["default"])(_this, "results", _descriptor, (0, _assertThisInitialized2["default"])(_this));
    (0, _initializerDefineProperty2["default"])(_this, "hasFocus", _descriptor2, (0, _assertThisInitialized2["default"])(_this));
    (0, _initializerDefineProperty2["default"])(_this, "isFetching", _descriptor3, (0, _assertThisInitialized2["default"])(_this));
    _this.dispose = void 0;
    _this.clearFocusTimeout = void 0;

    _this.onChange = function (e) {
      var _this$props = _this.props,
          onTextChange = _this$props.onTextChange,
          inputProps = _this$props.inputProps;
      var onChange = inputProps === null || inputProps === void 0 ? void 0 : inputProps.onChange;

      if (onChange) {
        onChange(e);
      }

      var text = e.text;

      _this.acquireFocus();

      onTextChange({
        text: text
      });
    };

    _this.onKeyUp = function (keyCode) {
      var _assertThisInitialize = (0, _assertThisInitialized2["default"])(_this),
          results = _assertThisInitialize.results,
          _assertThisInitialize2 = _assertThisInitialize.props,
          text = _assertThisInitialize2.text,
          inputProps = _assertThisInitialize2.inputProps;

      var onKeyUp = inputProps === null || inputProps === void 0 ? void 0 : inputProps.onKeyUp;

      if (onKeyUp) {
        onKeyUp(keyCode);
      }

      if (!text) {
        return;
      }

      if (keyCode == 13) {
        // Enter pressed
        if ((text === null || text === void 0 ? void 0 : text.length) > 0 && (results === null || results === void 0 ? void 0 : results.length) > 0) {
          _this.onResultSelected(results[0]);

          _this.looseFocus();
        }
      }
    };

    _this.onResultSelected = function (item) {
      var onSelection = _this.props.onSelection;
      onSelection({
        item: item
      });
    };

    _this.renderOptions = function () {
      var _assertThisInitialize3 = (0, _assertThisInitialized2["default"])(_this),
          showResults = _assertThisInitialize3.showResults,
          results = _assertThisInitialize3.results,
          _assertThisInitialize4 = _assertThisInitialize3.props,
          renderItem = _assertThisInitialize4.renderItem,
          optionClassName = _assertThisInitialize4.optionClassName;

      if (!showResults) {
        return null;
      }

      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _styling.css)(_this.styles.options)
      }, results.map(function (item, index) {
        var Content = function Content() {
          var content = renderItem({
            item: item,
            index: index
          });

          if (typeof content == "string") {
            return /*#__PURE__*/_react["default"].createElement("div", {
              className: (0, _styling.css)(_this.styles.optionText)
            }, content);
          }

          return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, content);
        };

        var optionClassNames = optionClassName != null ? optionClassName({
          item: item,
          index: index
        }) : undefined;
        return /*#__PURE__*/_react["default"].createElement("div", {
          key: (0, _objectHash["default"])(item),
          className: (0, _styling.css)(_this.styles.option, optionClassNames),
          onClick: function onClick() {
            return _this.onResultSelected(item);
          }
        }, /*#__PURE__*/_react["default"].createElement(Content, null));
      }));
    };

    return _this;
  }

  (0, _createClass2["default"])(TypeaheadInput, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var delay = this.props.delay;
      this.dispose = (0, _mobx.reaction)( // eslint-disable-next-line react/destructuring-assignment
      function () {
        return _this2.props.text;
      }, function (query) {
        (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
          var getData, results;
          return _regenerator["default"].wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  getData = _this2.props.getData;
                  _this2.isFetching = true;
                  _context.next = 4;
                  return getData({
                    query: query || ""
                  });

                case 4:
                  results = _context.sent;
                  (0, _mobx.runInAction)(function () {
                    _this2.results = results;
                    _this2.isFetching = false;
                  });

                case 6:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }))();
      }, {
        delay: delay || 0,
        fireImmediately: true
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var dispose = this.dispose;

      if (dispose) {
        dispose();
      }

      this.dispose = null;
    }
  }, {
    key: "acquireFocus",
    value: function acquireFocus() {
      var hasFocus = this.hasFocus,
          clearFocusTimeout = this.clearFocusTimeout;
      var preventFocusAfterSelection = this.props.preventFocusAfterSelection;

      if (hasFocus) {
        return;
      }

      if (preventFocusAfterSelection && clearFocusTimeout != null) {
        clearTimeout(clearFocusTimeout);
        this.clearFocusTimeout = null;
        return;
      }

      this.hasFocus = true;

      if (clearFocusTimeout != null) {
        clearTimeout(clearFocusTimeout);
        this.clearFocusTimeout = null;
      }
    }
  }, {
    key: "looseFocus",
    value: function looseFocus() {
      var _this3 = this;

      var clearFocusTimeout = this.clearFocusTimeout;

      if (clearFocusTimeout != null) {
        clearTimeout(clearFocusTimeout);
      } // Prevent the popover window from disappearing too quickly
      // after selection is made. Delay long enough for click
      // event to register and propagate.


      this.clearFocusTimeout = setTimeout(function () {
        _this3.hasFocus = false;
      }, 600);
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var _this$props2 = this.props,
          text = _this$props2.text,
          disabled = _this$props2.disabled,
          inputProps = _this$props2.inputProps,
          className = _this$props2.className,
          style = _this$props2.style,
          getData = _this$props2.getData,
          onSelection = _this$props2.onSelection,
          onTextChange = _this$props2.onTextChange,
          renderItem = _this$props2.renderItem,
          delay = _this$props2.delay,
          popoverProps = (0, _objectWithoutProperties2["default"])(_this$props2, ["text", "disabled", "inputProps", "className", "style", "getData", "onSelection", "onTextChange", "renderItem", "delay"]);
      return /*#__PURE__*/_react["default"].createElement(_Popover["default"], (0, _extends2["default"])({
        position: "bottom center",
        popoverContent: this.renderOptions,
        popoverOpen: this.showResults,
        className: (0, _styling.css)(this.styles.root, className, style)
      }, popoverProps), /*#__PURE__*/_react["default"].createElement(_TextInput["default"], (0, _extends2["default"])({
        className: (0, _styling.css)(this.styles.root, className, style)
      }, inputProps, {
        disabled: disabled,
        onFocus: function onFocus(e) {
          var onFocus = inputProps === null || inputProps === void 0 ? void 0 : inputProps.onFocus;

          if (onFocus) {
            onFocus(e);
          }

          _this4.acquireFocus();
        },
        onBlur: function onBlur(e) {
          var onBlur = inputProps === null || inputProps === void 0 ? void 0 : inputProps.onBlur;

          if (onBlur) {
            onBlur(e);
          }

          _this4.looseFocus();
        },
        onKeyUp: this.onKeyUp,
        onChange: this.onChange,
        value: text
      })));
    }
  }, {
    key: "styles",
    get: function get() {
      var isFetching = this.isFetching;
      var _this$context$theming = this.context.theming,
          _this$context$theming2 = _this$context$theming.theme,
          surfaceLightest = _this$context$theming2.surfaceLightest,
          primary = _this$context$theming2.primary,
          textBlack = _this$context$theming2.textBlack,
          fonts = _this$context$theming.fonts;
      return _aphrodite.StyleSheet.create({
        root: {},
        options: {
          display: "flex",
          flexDirection: "column",
          alignItems: "stretch",
          minWidth: 250,
          maxHeight: 400,
          overflowY: "auto"
        },
        option: {
          padding: "10px 16px",
          cursor: "pointer",
          userSelect: "none",
          fontFamily: fonts.regular,
          backgroundColor: surfaceLightest,
          ":hover": {
            backgroundColor: "".concat(primary, "33") // 20% transparency

          },
          transition: "background-color 0.3s linear",
          opacity: isFetching ? 0.5 : 1
        },
        optionText: {
          fontSize: 14,
          fontFamily: fonts.regular,
          lineHeight: 1.43,
          letterSpacing: "normal",
          color: textBlack,
          transition: "color 0.2s linear",
          ":hover": {
            color: primary
          }
        }
      });
    }
  }, {
    key: "showResults",
    get: function get() {
      var results = this.results,
          hasFocus = this.hasFocus,
          disabled = this.props.disabled;
      return !disabled && hasFocus && (results === null || results === void 0 ? void 0 : results.length) > 0;
    }
  }]);
  return TypeaheadInput;
}(_react.Component), _class3.contextType = _providers.LegoContext, _class3.demoProps = {
  text: "product",
  onTextChange: function onTextChange(_ref2) {
    var text = _ref2.text;
  },
  getData: function () {
    var _getData = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(_ref3) {
      var query;
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              query = _ref3.query;
              return _context2.abrupt("return", [{
                product_id: "a",
                name: "Product 1"
              }, {
                product_id: "b",
                name: "Product 2"
              }]);

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    function getData(_x) {
      return _getData.apply(this, arguments);
    }

    return getData;
  }(),
  onSelection: function onSelection(_ref4) {
    var item = _ref4.item;
  },
  renderItem: function renderItem(_ref5) {
    var item = _ref5.item;
    return item.name;
  },
  inputProps: {
    placeholder: "Search for a product"
  }
}, _class3.propDoc = {
  text: {
    required: true,
    type: "string",
    description: "Current text in the input field"
  },
  onTextChange: {
    required: true,
    type: "(args: { text: string }) => mixed",
    description: "Callback for when the text changes"
  },
  onSelection: {
    required: true,
    type: "(args: { item: any }) => mixed",
    description: "Callback for when a selection is made from one of the " + "options"
  },
  getData: {
    required: true,
    type: "(args: { query: string }) => Promise<$ReadOnlyArray<any>>",
    description: "Delegate for fetching results based on the current search" + " query"
  },
  renderItem: {
    required: true,
    type: "(args: { item: any, index: number }) => (string | ReactNode)",
    description: "Callback to render a typeahead option. Return a the " + "option name as a string if no custom rendering is needed"
  },
  optionClassName: {
    required: false,
    type: "(args: { item: any; index: number }) => any | null | undefined",
    description: "Callback to optionally provide a className or style object for the " + "option in the list containing the item. The index of the option is " + "also given."
  },
  disabled: {
    required: false,
    defaultValue: "false",
    type: "boolean",
    description: "Indicates that the field is disabled. Set while making " + "API calls to submit data"
  },
  inputProps: {
    required: false,
    defaultValue: "null",
    type: "?TextInputProps",
    description: "Props to pass to the underlying [TextInput](/?path=/docs/form-textinput--example) " + "component if you need to customize it"
  },
  delay: {
    required: false,
    defaultValue: "0",
    type: "?number",
    description: "Time delay (in milliseconds) of input before calling getData again."
  },
  preventFocusAfterSelection: {
    required: false,
    defaultValue: undefined,
    type: "?boolean",
    description: "Prevents text input from refocusing for the period after " + "selecting a result when the popover is being kept open to allow for " + "propagation. This can be used when auto-filling a form with multiple " + "autocomplete fields using TypeaheadInput"
  }
}, _class3.demoRender = "\n  <TypeaheadInput\n    text=\"product\"\n    onTextChange={({ text, item }) => {}}\n    getData={({ query }) => new Promise([\n      { product_id: \"a\", name: \"Product 1\" },\n      { product_id: \"b\", name: \"Product 2\" }\n    ])}\n    onSelection={({ item }) => {}}\n    renderItem={({ item }) => item.name}\n    inputProps={{\n      placeholder: \"Search for a product\"\n    }}\n  />;\n", _temp), (_descriptor = (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "results", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor2 = (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "hasFocus", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor3 = (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "isFetching", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "styles", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "styles"), _class2.prototype), (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "showResults", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "showResults"), _class2.prototype)), _class2)) || _class;

exports["default"] = TypeaheadInput;